import * as React from 'react';
import styled from '@emotion/styled';
import Image from '@base/Image';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';

interface IBatchNudge {
  batchCount: number;
  hideNudge: () => void;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: var(--color-base-1);
  border: ${Spacings.SPACING_1} solid var(--color--divider);
  border-radius: ${Spacings.SPACING_1B};
  margin-bottom: ${Spacings.SPACING_8B};
  box-shadow: ${boxShadowGenerator()};
  height: 171px;
`;

const Heading = styled(Typography)`
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    max-width: 160px;
    line-height: ${Spacings.SPACING_6B};
  }
`;

const Text = styled(Typography)`
  font-weight: ${Fonts.LIGHT};
  margin-top: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    max-width: 160px;
    margin-top: 0px;
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;

const InnerWrapper = styled.div`
  padding: ${Spacings.SPACING_6B} 0 ${Spacings.SPACING_6B}
    ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B}
      ${Spacings.SPACING_4B};
  }
`;

const BatchNudge: React.FC<IBatchNudge> = ({ batchCount, hideNudge }) => {
  const isMobile = useIsMobile();

  if (!batchCount) return null;

  return (
    <Wrapper>
      <InnerWrapper>
        <Heading color="var(--color-text-primary)" variant="h4">
          {`You’re learning from ${batchCount} batch${
            batchCount === 1 ? '' : 'es'
          }`}
        </Heading>
        <Text color="var(--color-text-secondary)" variant="p3">
          We recommend you learn from 1 batch only, and leave from those you
          don’t need
        </Text>
        <Button
          label="Got it"
          variant="secondary"
          onClick={hideNudge}
          size="small"
        />
      </InnerWrapper>
      <Image
        src="batch-enrollment.svg"
        width={isMobile ? '100px' : '113px'}
        height={isMobile ? '150px' : '169.5px'}
        alt="batch"
      />
    </Wrapper>
  );
};

export default BatchNudge;
